module.exports = __webpack_public_path__ + "static/img/regionButton.841c8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regionButton.png
// module id = VId7
// module chunks = 4